import React from "react";
import { ShowProps, TextField } from "react-admin";
import { Button, Grid, makeStyles, Typography } from "@material-ui/core";
import SanitizedGrid from "components/SanitizedGrid";
import { GridinRowsWithSpace } from "utils/style";
import CustomDateField from "components/CustomDateField";
import { Link } from "react-router-dom";
import EditIcon from "@material-ui/icons/Edit";
import { availableOnlySuperAdminAndAdminAndFinance } from "utils/tools";
import StatusField from "components/StatusField";
import CustomLabeled from "../../components/layout/CustomLabeled";

const useStyles = makeStyles({
  summaryButton: {
    position: "relative",
    top: 20,
  },
  table: {
    minWidth: 650,
  },
});

const Summary = (props: ShowProps) => {
  const classes = useStyles();

  return (
    <SanitizedGrid container spacing={2}>
      <Grid item xs={12} style={GridinRowsWithSpace}>
        <Typography variant="h6">Company Detail</Typography>

        {availableOnlySuperAdminAndAdminAndFinance() && (
          <Button
            className={classes.summaryButton}
            variant="contained"
            color="primary"
            component={Link}
            to={{
              pathname: `/companies/${Number(props.id)}`,
            }}
            startIcon={<EditIcon />}
          >
            Edit
          </Button>
        )}
      </Grid>

      <Grid item xs={12}>
        <CustomLabeled name="Id">
          <TextField source="id" />
        </CustomLabeled>
      </Grid>

      <Grid item xs={12}>
        <CustomLabeled name="Name">
          <TextField source="name" />
        </CustomLabeled>
      </Grid>

      <Grid item xs={3}>
        <CustomLabeled name="Email">
          <TextField source="user.email" />
        </CustomLabeled>
      </Grid>
      <Grid item xs={3}>
        <CustomLabeled name="Mobile">
          <TextField source="mobile" />
        </CustomLabeled>
      </Grid>
      <Grid item xs={6}></Grid>

      <Grid item xs={3}>
        <CustomLabeled name="Status">
          <StatusField source="status" />
        </CustomLabeled>
      </Grid>

      <Grid item xs={3}>
        <CustomLabeled name="Register Date">
          <CustomDateField source="createdAt" emptyText="-" isDateTime />
        </CustomLabeled>
      </Grid>
      <Grid item xs={6}></Grid>

      <Grid item xs={3}>
        <CustomLabeled name="Va Number">
          <TextField source="vaNumber" emptyText="-" />
        </CustomLabeled>
      </Grid>
      <Grid item xs={3}>
        <CustomLabeled name="Mbc Code">
          <TextField source="user.mbcCustomerId" emptyText="-" />
        </CustomLabeled>
      </Grid>
      <Grid item xs={6}></Grid>

      <Grid item xs={12}>
        <Typography variant="h6">Address Info</Typography>
      </Grid>

      <Grid item xs={12}>
        <CustomLabeled name="address">
          <TextField source="address" emptyText="-" />
        </CustomLabeled>
      </Grid>

      <Grid item xs={3}>
        <CustomLabeled name="Block No.">
          <TextField source="blockNumber" emptyText="-" />
        </CustomLabeled>
      </Grid>

      <Grid item xs={3}>
        <CustomLabeled name="Unit No.">
          <TextField source="unit" emptyText="-" />
        </CustomLabeled>
      </Grid>
      <Grid item xs={6}></Grid>

      <Grid item xs={3}>
        <CustomLabeled name="Building Name">
          <TextField source="building" emptyText="-" />
        </CustomLabeled>
      </Grid>

      <Grid item xs={3}>
        <CustomLabeled name="postalCode">
          <TextField source="postalCode" emptyText="-" />
        </CustomLabeled>
      </Grid>
    </SanitizedGrid>
  );
};

export default Summary;
